import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-edit',
  templateUrl: './context-menu-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuEditComponent {
  @Output()
  editClick = new EventEmitter();
}
